var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pen",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.575,
    height: 14.504,
    viewBox: "0 0 14.575 14.504",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1480",
    "data-name": "Path 1480",
    d: "M9.064,3.709l2.965,2.965L4.524,14.179,1.56,11.214Zm5.215-.715L12.956,1.672a1.312,1.312,0,0,0-1.853,0L9.836,2.939,12.8,5.9l1.477-1.477A1.011,1.011,0,0,0,14.279,2.994ZM.009,15.382a.337.337,0,0,0,.408.4l3.3-.8L.758,12.017Z",
    transform: "translate(-0.001 -1.289)",
    fill: "#00529f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/Pen.d12c5162a53ab9e1ab7dd7a151bcf88f.svg";
export { ForwardRef as ReactComponent };